import type * as api from '@gitbook/api-client';
import type { NavigationScreenState } from '@gitbook/app-navigation';
import { PaletteAtomButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { SidebarItemIcon, useSidebarItem } from '@gitbook/spine-react';

import { OrganizationIcon } from '../../Components';
import { useGetSettingsPalette } from './SettingsPalette';

/**
 * Sidebar button that opens the organization settings palette.
 */
export function OrganizationButton(props: {
    organization: api.Organization;
    screen: NavigationScreenState;
    iconOnly?: boolean;
}) {
    const { iconOnly, organization, screen } = props;

    const palette = useGetSettingsPalette({ organization, screen });
    const { itemProps } = useSidebarItem({
        'data-testid': 'sidebar.orgButton',
        size: 'large',
        icon: <OrganizationIcon organization={organization} />,
        label: organization.title,
        iconOnly,
        className: iconOnly ? 'rounded-md' : undefined,
        elementType: 'button',
        title: iconOnly ? organization.title : undefined,
        children: <SidebarItemIcon icon={Icon.ChevronDown} />,
    });

    return <PaletteAtomButton palette={palette} {...itemProps} className={itemProps.className} />;
}
